import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardEcommerce from "../pages/DashboardEcommerce";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import { components } from "react-select";
import ExecutiveDashboard from "../pages/executive";
import CreateRequisition from "../pages/executive/CreateRequisition";
import RequisitionHistory from "../pages/executive/RequisitionHistory";
import AddRequisition from "../pages/executive/AddRequisition";

//sales Head
import SalesDashboard from '../pages/salesHead/index'
import SalesCreateRequisition from "../pages/salesHead/CreateRequisition";
// import AddSalesRequisition from "../pages/executive/AddRequisition";
import AddSalesRequisition from "../pages/salesHead/AddSalesRequisition";
import SalesRequisitionHistory from "../pages/salesHead/RequisitionHistory";
import SalesRequisitionTab from "../pages/salesHead/RequisitionTabs";
import SalesApprovalAddRequisiton from "../pages/salesHead/ApprovalAddRequisition";
import SubmissionRequisition from "../pages/salesHead/SubmissionRequisition";

//RSM
import RSMDashboard from '../pages/RSM/index'
// import RSMCreateRequisition from "../pages/RSM/createRSMRequisition";
import NewRsmCreateRequisition from "../pages/RSM/NewRsmCreateRequisition";
import RSMRequisitionHistory from '../pages/RSM/RSMRequisitionHistory';
import AddRSMRequisition from "../pages/RSM/AddRMSRequistion";
import RMSRequisitionTab from "../pages/RSM/RSMRequsitionTabs";

//Purchase Manager
import PurchaseManagerDashboard from '../pages/PurchaseManager/index';
// import PurchaseCreateRequisition from '../pages/PurchaseManager/PurchaseCreateRequisition'
import NewPurchaseCreateRequisition from "../pages/PurchaseManager/NewPurchaseCreateRequisition";
import PurchaseRequisition from '../pages/PurchaseManager/ApprovalRequisition';
import PurchaseApprovalAddRequisiton from "../pages/PurchaseManager/AddApprovalRequisition";
import PurchasemanagerRequisitionTabs from "../pages/PurchaseManager/RequisitionTabs";
import AddPurchaseRequisition from "../pages/PurchaseManager/AddPurchaseRequisition";
import PurchaseAssignVendor from "../pages/PurchaseManager/AssignVendor";
// import PurchasemanagerRequisitionHistory from "../pages/PurchaseManager/PurchasemanagerRequisitionHistory";
import PurchasemanagerRequisitionHistory from "../pages/PurchaseManager/RSMAllocation/AddRequisitionTabs";
import PurchaseMyPO from "../pages/PurchaseManager/MyPO";
// import SalesHeadCreateRequisition from "../pages/salesHead/SalesHeadCreateRequisition";
import NewSalesHeadCreateRequisition from "../pages/salesHead/NewSalesHeadCreateRequisition";
import RSMAllocation from "../pages/PurchaseManager/RSMAllocation/index";
import RSMAddAllocation from "../pages/PurchaseManager/RSMAllocation/AddAllocation";
import RMSAllocationTab from "../pages/PurchaseManager/RSMAllocation/AddRequisitionTabs";
import Managementapprove from "../pages/PurchaseManager/RSMAllocation/ManagementApproval";
import GeneratePo from "../pages/PurchaseManager/RSMAllocation/GeneratePo";
import RSMSubmissionRequisition from "../pages/RSM/RSMSubmissionRequisition";
import PurchaseSubmissionRequisition from "../pages/PurchaseManager/PurchaseSubmissionRequisition";
import PurchaseApprovalRequistion from "../pages/PurchaseManager/ApprovalRequisition";
import DateUpdate from '../pages/PurchaseManager/RSMAllocation/DateUpdate';
import UserArrivalDateUpdate from '../pages/PurchaseManager/RSMAllocation/UserArrivalDateUpdate';
import ManagementApprove from '../pages/PurchaseManager/ManagementApprove';
import Invoice from '../pages/PurchaseManager/Invoice/Invoice';
import AddInvoice from "../pages/PurchaseManager/Invoice/AddInvoice";
import IGM from '../pages/PurchaseManager/Invoice/IGM';
import InvoicePI from '../pages/PurchaseManager/Invoice/InvoicePI';
import Telx from '../pages/PurchaseManager/Invoice/Texl';
import Logistic from '../pages/PurchaseManager/Invoice/Logistics';
import GRN from '../pages/PurchaseManager/Invoice/GRN';
import Tagging from '../pages/PurchaseManager/Invoice/Tagging';
import Customs from '../pages/PurchaseManager/Invoice/Customs';
import POPayment from '../pages/PurchaseManager/Payment/POPayment';
import Insurance from '../pages/PurchaseManager/Invoice/Insurance';
import PaymentInsurance from '../pages/PurchaseManager/Payment/Insurance';
import PaymentFreightCharges from '../pages/PurchaseManager/Payment/FreightCharges';

import DutyFee from '../pages/PurchaseManager/Payment/DutyFee';
import FreightCharges from '../pages/PurchaseManager/Invoice/FreightCharges';
import AllInvoices from '../pages/PurchaseManager/Invoice/AllInvoices';
import UpdateUserDate from "../pages/PurchaseManager/RSMAllocation/newUserArrivalDateUpdate";


//Management
import ManagementDashboard from "../pages/Management";
import ManagementApprovalRequisition from '../pages/Management/Requisition/ApprovalRequisition';
import ApprovalRequisitionDetails from '../pages/Management/Requisition/ApprovalDetailsRequisition';
import ManagementHistoryRequistion from '../pages/Management/Requisition/RequisitionHistory'
import UpdateVendorDate from "../pages/PurchaseManager/VendorDateUpdate/UpdateVendorDate";
import ManagementApproveGeneratePo from "../pages/PurchaseManager/ManagementApproveGeneratePO";
import NewCreateRequisition from "../pages/executive/NewCreateRequisition";

const authProtectedRoutes = [

  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/dashboard" />,
  // },
  // { path: "*", component: <Navigate to="/dashboard" /> },
  {path:"/executive/dashboard", component: <ExecutiveDashboard/>},
  // {path:"/executive/create-requisition", component: <CreateRequisition/>},
  {path:"/executive/create-requisition", component: <NewCreateRequisition/>},


  {path:"/executive/add-requisition", component: <AddRequisition/>},
  {path:"/executive/requisition-history", component: <RequisitionHistory/>},
  {path:"/sales-head/dashboard", component: <SalesDashboard/>},
  // {path:"/sales-head/create-requisition", component: <SalesHeadCreateRequisition/>},
  {path:"/sales-head/create-requisition", component: <NewSalesHeadCreateRequisition/>},


  {path:"/sales-head/add-requisition", component: <AddSalesRequisition/>},
  {path:"/sales-head/requisition-history", component: <SalesRequisitionHistory/>},
  {path:"/sales-head/approval-requisition", component: <SalesRequisitionTab/>},
  {path:"/sales-head/aproval-add-requisition", component: <SalesApprovalAddRequisiton/>},
  {path:"/sales-head/after-aproval-add-requisition", component: <SubmissionRequisition/>},

  {path:'/RSM-dashboard', component: <RSMDashboard /> },
  //  {path:'/rsm/create-requisition', component: < RSMCreateRequisition /> },
  {path:'/rsm/create-requisition', component: < NewRsmCreateRequisition /> },

   {path:'/rsm/requistion-history', component: <RSMRequisitionHistory /> },
   {path:'/rsm/add-requisition', component: <AddRSMRequisition /> },
   {path:"/rsm/approval-requisition", component: <RMSRequisitionTab/>},
   {path:"/rsm/after-aproval-add-requisition", component: <RSMSubmissionRequisition/>},

   {path:'/purchase-manager-dashboard', component: <PurchaseManagerDashboard /> },
   { path:'/purchase-manager-requistion', component: <PurchaseRequisition /> },
   {path:"/purchase-manager-approval-requisition", component: <PurchasemanagerRequisitionTabs />},
   {path:"/purchase-manager/add-requisition", component: <AddPurchaseRequisition />},
  //  {path:'/purchase-manager/create-requisition', component: <PurchaseCreateRequisition /> },
  {path:'/purchase-manager/create-requisition', component: <NewPurchaseCreateRequisition /> },

   {path:'/purchase-manager-assign-vendor', component: <PurchaseAssignVendor />},
   {path:'/purchase-manager/requisition-history', component: <PurchasemanagerRequisitionHistory /> },
  {path:"/purchase-manager/after-aproval-add-requisition", component: <PurchaseSubmissionRequisition/>},
  {path:'/purchase-manager/generate-po', component: <GeneratePo /> },
  {path:'/purchase-manager/vendor-update-date', component: <UpdateVendorDate /> },

  {path:'/purchase-manager/rsm-allocation', component: <RSMAllocation /> },
  {path:'/purchase-manager/requisition/requisition-history', component: <RMSAllocationTab />},
  {path:'/purchase-manager/requisition/management-approval', component: <Managementapprove />},
  {path:'/purchase-manager/rms/add-allocation', component: <RSMAddAllocation />},
  {path:'/purchase-manager/approval-requisition', component: <PurchaseApprovalRequistion />},
  {path:'/purchase-manager/date-update', component: <DateUpdate />},
  {path:'/purchase-manager/user-arrival-date-update', component: <UpdateUserDate />},

  // {path:'/purchase-manager/user-arrival-date-update', component: <UserArrivalDateUpdate />},

  {path:'/purchase-manager/management-approve', component: <ManagementApprove />},
  {path:'/purchase-manager/management-approve-po-generate', component: <ManagementApproveGeneratePo />},
  {path:'/purchase-manager/invoice/invoice', component: <Invoice />},
  {path:'/purchase-manager/invoice/add-invoice', component: <AddInvoice />},

  {path:'/purchase-manager/invoice/insurance', component: <Insurance />},
  {path:'/purchase-manager/invoice/freight-charges', component: <FreightCharges />},

  {path:'/purchase-manager/invoice/igm', component: <IGM />},
  {path:'/purchase-manager/invoice/invoice-pi', component: <InvoicePI />},
  {path:'/purchase-manager/invoice/telx', component: <Telx />},
  {path:'/purchase-manager/invoice/grn', component: <GRN />},
  {path:'/purchase-manager/invoice/logistic', component: <Logistic />},
  {path:'/purchase-manager/invoice/Tagging', component: <Tagging />},
  {path:'/purchase-manager/invoice/customs', component: <Customs />},
  {path:'/purchase-manager/payment/po-payment', component: <POPayment />},
  {path:'/purchase-manager/payment/duty-fee', component: <DutyFee />},
  {path:'/purchase-manager/payment/insurance', component: <PaymentInsurance />},
  {path:'/purchase-manager/payment/freight-charges', component: <PaymentFreightCharges />},
  {path:'/purchase-manager/invoice/all-invoices', component: <AllInvoices />},
  
  {path:'/management-dashboard', component: <ManagementDashboard />},
  {path:'/management/approval-requisition', component: <ManagementApprovalRequisition />},
  {path:'/management/approval-requisition-details', component: <ApprovalRequisitionDetails />},
  {path:'/management/approval-requisition-history', component: <ManagementHistoryRequistion />},
  
  {path:'/purchase-manager/my-po', component: <PurchaseMyPO />},






  { path: "/", exact: true, component: <Navigate to="/executive/dashboard" /> }
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };